import { subscribeToQuery } from 'datocms-listen'
import { gql } from 'graphql-tag'
import { mapGetters } from 'vuex'

export const execQuery = async ({ $contentAPI, error, $sentry, query, $route, store, $store }, gqlQuery, raw = false) => {
  const preview = process.client && ((query || $route.query).preview || (store || $store).getters['page/contentPreviewEnabled'])
  const result = await $contentAPI.fetch({ query: gqlQuery, preview })

  if ((query || $route.query).preview) store.commit('page/SET_CONTENT_PREVIEW_STATE', true)
  
  const selections = getSelectionsFromQuery(gqlQuery)
  const selectionsMissing = selections.some(selection => !result[selection])

  if (!result || selectionsMissing || result.errors) {
    const errorsToLog = result.errors || 'Error fetching page'
    $sentry.captureException(errorsToLog)
    return error({ statusCode: 404, message: 'Unable to load page' })
  }

  if (raw) return result

  return {
    ...Object.assign(...selections.map(selection => result[selection])),
    query: gqlQuery
  }
}

const getSelectionsFromQuery = (query) => {
  const parsedQuery = gql(query)
  return parsedQuery.definitions.map(
    def => def.selectionSet.selections.map(
      selection => selection.name.value
    )
  ).flat()
}

export const contentAPIMixin = {
  async mounted () {
    if (this.$route.query.preview || this.contentPreviewEnabled) {
      this.unsubscribe = await subscribeToQuery({
        token: this.$config.datoApiToken,
        query: this.query,
        preview: true,
        onChannelError: this.onChannelError,
        onUpdate: this.onUpdate
      })
    }
  },
  computed: {
    ...mapGetters({
      contentPreviewEnabled: 'page/contentPreviewEnabled'
    })
  },
  watch: {
    contentPreviewEnabled () {
      if (!this.contentPreviewEnabled) this.unsubscribe()
    }
  },
  methods: {
    unsubscribe () {},
    onChannelError (error) {
      console.error(error)
    },
    onUpdate (update) {
      const selections = getSelectionsFromQuery(this.query)
      selections.forEach((selection) => {
        if (!(selection in update.response.data)) return
        for (const field in update.response.data[selection]) {
          this.$set(this, field, update.response.data[selection][field])
        }
      })
    },
    async refreshContent () {
      const preview = process.client && (this.$route.query.preview || this.$store.getters['page/contentPreviewEnabled'])
      const result = await this.$contentAPI.fetch({ query: this.query, preview })
      this.onUpdate({ response: { data: result } })
    }
  }
}